import { emailManagerConstants } from '../constants/emailManagerConstants';
import { emailManagerService } from '../../services/API/emailManagerService';
import { alertActions } from './alert.actions';
import { history }              from '../store/configureStore';
import Alert     from '../../components/alert/Alert';


export const  emailOverview = (postData) => {
    return dispatch => {
        emailManagerService.emailOverview(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.VIEW_OVERVIEW_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.VIEW_OVERVIEW_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.VIEW_OVERVIEW_FAILURE, error } }
}

export const  getCoutnryCity = (data) => {
    return dispatch => {
        emailManagerService.getCoutnryCity(data)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_COUNTRYCITY_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_COUNTRYCITY_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_COUNTRYCITY_FAILURE, error } }
}

export const  createEmailManager = (postData) => {
    return dispatch => {
        emailManagerService.createEmailManager(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.POST_CREATEEMAIL_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.POST_CREATEEMAIL_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.POST_CREATEEMAIL_FAILURE, error } }
}


export const  getEmailManagerDetail = (id, siteID) => {
    return dispatch => {
        emailManagerService.getEmailManagerDetail(id, siteID)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_DETAIL_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_DETAIL_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_DETAIL_FAILURE, error } }
}

export const  editEmailManager = (id) => {
    return dispatch => {
        emailManagerService.editEmailManager(id)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.EDIT_DETAIL_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.EDIT_DETAIL_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.EDIT_DETAIL_FAILURE, error } }
}

export const  deleteEmail = (id) => {
    return dispatch => {
        emailManagerService.deleteEmail(id)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.DELETE_DETAIL_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.DELETE_DETAIL_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.DELETE_DETAIL_FAILURE, error } }
}

export const  sendTestMail = (postData) => {
    return dispatch => {
        emailManagerService.sendTestMail(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.SEND_TESTMAIL_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.SEND_TESTMAIL_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.SEND_TESTMAIL_FAILURE, error } }
}

export const  getDealList = (postData) => {
    return dispatch => {
        emailManagerService.getDealList(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_DEAL_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_DEAL_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_DEAL_FAILURE, error } }
}

export const  emailTemplate = (postData) => {
    return dispatch => {
        emailManagerService.emailTemplate(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_TEMPLATE_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_TEMPLATE_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_TEMPLATE_FAILURE, error } }
}

export const  exportSubscriber = (postData) => {
    return dispatch => {
        emailManagerService.exportSubscriber(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.POST_EXPORT_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.POST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.POST_EXPORT_FAILURE, error } }
}

export const  exportUsers = (postData) => {
    return dispatch => {
        emailManagerService.exportUsers(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.POST_EXPORT_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.POST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.POST_EXPORT_FAILURE, error } }
}

export const  importSubscriberList = (postData, url) => {
    return dispatch => {
        emailManagerService.importSubscriberList(postData, url)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.POST_IMPORT_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.POST_IMPORT_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.POST_IMPORT_FAILURE, error } }
}

export const  getSubscriberFile = (postData) => {
    return dispatch => {
        emailManagerService.getSubscriberFile(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_FILELIST_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_FILELIST_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_FILELIST_FAILURE, error } }
}

export const  disableFile = (fileID) => {
    return dispatch => {
        emailManagerService.disableFile(fileID)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_DISABLE_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_DISABLE_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_DISABLE_FAILURE, error } }
}

export const  getTotalSubscriber = (fileID) => {
    return dispatch => {
        emailManagerService.getTotalSubscriber(fileID)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_TOTAL_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_TOTAL_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_TOTAL_FAILURE, error } }
}

export const  addNotification = (formData, url) => {
    return dispatch => {
        emailManagerService.addNotification(formData, url)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.POST_NOTIFICATION_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.POST_NOTIFICATION_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.POST_NOTIFICATION_FAILURE, error } }
}

export const  notification = (postData) => {
    return dispatch => {
        emailManagerService.notification(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.VIEW_OVERVIEW_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.VIEW_OVERVIEW_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.VIEW_OVERVIEW_FAILURE, error } }
}

export const  getNotification = (notificationId) => {
    return dispatch => {
        emailManagerService.getNotification(notificationId)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.GET_NOTIFICATION_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.GET_NOTIFICATION_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.GET_NOTIFICATION_FAILURE, error } }
}

export const  emailStatus = (postData) => {
    return dispatch => {
        emailManagerService.emailStatus(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: emailManagerConstants.POST_VIEWSTATS_REQUEST, data } }
    function success(data) { return { type: emailManagerConstants.POST_VIEWSTATS_SUCCESS, data } }
    function failure(error) { return { type: emailManagerConstants.POST_VIEWSTATS_FAILURE, error } }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/emailManagerActions.js